import {DiscoverGameGameAnalysisResponse} from "libs/apiClient";
import {Link} from "react-router";
import {formatDateTime} from "features/discover/functions";

export function GameAnalysisTable({
	gameAnalysisData
}: {
	gameAnalysisData: DiscoverGameGameAnalysisResponse[]
}) {
	if (gameAnalysisData.length === 0) {
		return <div className="empty-sub-table">No analysis</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Provider</th>
					<th>Status</th>
					<th>Created At</th>
					<th>Requested At</th>
					<th>Priority</th>
					<th>First Available At</th>
					<th>Analyzed At</th>
				</tr>
			</thead>
			<tbody>
				{gameAnalysisData.map((ga: DiscoverGameGameAnalysisResponse, index) => (
					<tr key={`row-${index}`}>
						<td>
							{ga.id}
						</td>
						<td>
							<strong>{ga.provider || "-"}</strong>
						</td>
						<td>
							{ga.status || "-"}
						</td>
						<td>
							{formatDateTime(ga.createdAt) || "-"}
							{ga.createdBy && <Link to={`/discover/user/${ga.createdBy.id}`}>
								<br/><strong style={{fontSize: '.8em'}}>{ga.createdBy.name}</strong>
							</Link>}
						</td>
						<td>
							{formatDateTime(ga.requestedAt) || "-"}
							{ga.requestedBy && <Link to={`/discover/user/${ga.requestedBy.id}`}>
								<br/><strong style={{fontSize: '.8em'}}>{ga.requestedBy.name}</strong>
							</Link>}
						</td>
						<td>
							{ga.priority || "-"}
						</td>
						<td>
							{formatDateTime(ga.firstAvailableAt) || "-"}
						</td>
						<td>
							{formatDateTime(ga.analyzedAt) || "-"}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
